import React from 'react';
import { useOnboardingContext } from '../../../contexts/Onboarding';
import { useSnackbarContext } from '../../../contexts/Snackbar';
import { useLinesContext } from '../../../contexts/Lines';
import { useEventTrackerContext } from '../../../contexts/EventTracker';
import { updateProduct } from '../../API/product';
import { numberValidation } from '../../../utils/formikValidations';
import { convertToInt } from '../../../utils/string';
import { formatNumber } from '../../../utils/number';
import { Field } from 'formik';
import * as yup from 'yup';
import messages from '../../../messages';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Step from '../BuildingBlocks/Stepper/Step';
import NumberFormatTextField from '../../misc/NumberFormatTextField';
import cloneDeep from 'lodash.clonedeep';
import ProductDetails from './product-details/ProductDetails';

const useStyles = makeStyles((theme) => ({
  field: {
    maxWidth: 400,
    '& .MuiOutlinedInput-root': {
      borderRadius: theme.spacing(1),
    },
  },
}));

export default function ProductNumShipments() {
  const classes = useStyles();
  const snackbar = useSnackbarContext();
  const { trackEvent } = useEventTrackerContext();
  const { setLoading, goForward } = useOnboardingContext();
  const { products, setProducts } = useLinesContext();

  const newestProduct = products[products?.length - 1];

  async function handleSubmit(values: { shipments: string }) {
    let shipments = convertToInt(values.shipments);
    if (!newestProduct) {
      return snackbar.show(messages.product.errors.notFoundUpdate, 'error');
    }
    try {
      if (newestProduct?.numShipmentsLastYear !== shipments) {
        setLoading(true);
        await updateProduct(newestProduct?.id, {
          numShipmentsLastYear: shipments,
        });
        const updatedProducts = cloneDeep(products).map((product) => {
          if (product.id === newestProduct.id) {
            product['numShipmentsLastYear'] = shipments;
          }
          return product;
        });
        setProducts(updatedProducts);
      }
      trackEvent({
        event: 'entered_no_of_batches',
        batch_amount: shipments,
      });
      goForward();
    } catch (error) {
      snackbar.show(messages.general.saveError, 'error');
    }
    setLoading(false);
  }

  return (
    <Step
      initialValues={{
        shipments: newestProduct?.numShipmentsLastYear
          ? formatNumber(newestProduct.numShipmentsLastYear)
          : '',
      }}
      validationSchema={yup.object({
        shipments: numberValidation,
      })}
      onSubmit={handleSubmit}
      component={() => {
        return (
          <ProductDetails product={newestProduct} step={3}>
            <Field
              name="shipments"
              label="Batches purchased"
              component={NumberFormatTextField}
              variant="outlined"
              fullWidth
              className={classes.field}
            />
          </ProductDetails>
        );
      }}
    />
  );
}
